module.exports = __webpack_public_path__ + "static/media/StarOutline.5fa7d437.svg";